import { t } from "i18next";
import React from "react";
import { RiDoorOpenLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import Colors from "../../constant/Colors";
import { bioOpenDoor } from "../../db/BioStar/APIs";
import separateFaceIdType from "../../utils/separateFaceIdType";
import { IoIosCloseCircleOutline } from "react-icons/io";

const smalltalk = require("smalltalk");

function DoorHandling({
  toggleDoorsModalHandler
}) {
  const doors = useSelector((state) => state.accessGroups.doors);
  const currentUser = useSelector((state) => state.authentication.user);

  const onPress = (door) => {
    const centerId = JSON.parse(localStorage.getItem("centerId")).centerId;
    toggleDoorsModalHandler()
    smalltalk
      .prompt("", t('writeDownTheReasonForOpeningTheDoor'), "", {
        buttons: {
          ok: t('open'),
          cancel: t('cancel'),
        }
      })
      .then(async (value) => {
        if (value) {
          let obj = {
            reasonLabel: value,
            adminId: currentUser._id,
            door,
            centerId,
          };
          await bioOpenDoor(obj, true);
        }
      })
      .catch(() => {
        console.log("cancel");
      });
  };
  // console.log({ doors })
  return (
    <div className="relative w-full h-full bg-black/25" >
      <div className="absolute flex flex-col items-center w-1/2 p-2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg h-fit top-1/2 left-1/2" >
        <div className="flex items-end justify-end w-full" >
          <IoIosCloseCircleOutline className="cursor-pointer" onClick={toggleDoorsModalHandler} color='red' size={27} />
        </div>
        <div className="w-full p-6" >
          {doors &&
            doors.length !== 0 &&
            doors.map((door, key) => {
              return (
                <button
                  key={key}
                  onClick={onPress.bind(this, door)}
                  className="flex items-center justify-between w-full p-3 border rounded-xl"
                >
                  <h1 className="font-bold text-darkCardExeternalIndex">
                    {t('openingTheDoor')} {t(door.name.split(' ')[0])}
                  </h1>
                  <RiDoorOpenLine color={Colors.darkCardExeternalIndex} size={30} />
                </button>
              );
            })}
          {(!doors || doors.length === 0) && <div className="flex justify-center w-full" >
            <p className="font-bold text-darkCardExeternalIndex" >{t('noDoorFoundPleaseCheckYourSystem')}</p>
          </div>}
        </div>

      </div>
    </div>
  );
}

export default DoorHandling;
